import tmhRequest from '@/config/tmhRequest'

export default {

    searchListPost: function (data) {
        return tmhRequest({
            url: '/hr/tmh/post/searchlistpost',
            method: 'post',
            params: data,
        })
    },

    addPost: function (data) {
        return tmhRequest({
            url: '/hr/tmh/post/addpost',
            method: 'post',
            params: data,
        })
    },

    editPost: function (data) {
        return tmhRequest({
            url: '/hr/tmh/post/editpost',
            method: 'post',
            params: data,
        })
    },

    deletePost: function (data) {
        return tmhRequest({
            url: '/hr/tmh/post/deletepost',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/hr/post.js